import React, { useState } from 'react';
import { DefaultInputPropTypes, InputList, useInputHelper } from 'framework/form';
import { Typography, Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import GridOnIcon from '@mui/icons-material/GridOn';
import PreviewTableTabularInput from './PreviewTableTabularInput';
import TabulerInputTemplate from './TabulerInputTemplate';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';

const DocumentTemplateTabularDataInputs = ({
  defaultValue = [],
  tableHeader = [],
  ...props
}: DefaultInputPropTypes<string[][]> & { tableHeader: string[] }) => {
  const { getSource, getValue } = useInputHelper(props);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const source = getSource();
  const value: string[][] = getValue() || [];

  const title = typeof props.label === 'string' ? props.label : '';

  const maxLength = React.useMemo(
    () => (defaultValue.length ? Math.max(0, ...defaultValue.map(arr => arr.length)) : tableHeader.length),
    [defaultValue, tableHeader],
  );

  return (
    <Box mb="20px">
      {/* Header */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography display="flex" gap="10px" color="primary" variant="h5">
          <GridOnIcon />
          {title}
        </Typography>

        <IconButton disabled={!maxLength} size="small" onClick={() => setIsModalOpen(true)}>
          <EditIcon color={!maxLength ? 'disabled' : 'primary'} fontSize="small" />
        </IconButton>
      </Box>

      {/* Preview */}
      <PreviewTableTabularInput rows={value} />

      {/* Modal */}
      <Modal
        modalSize="lg"
        backdrop="static"
        isOpen={isModalOpen}
        onToggle={() => setIsModalOpen(false)}
        buttons={[
          <Button key="ok" onClick={() => setIsModalOpen(false)}>
            Ok
          </Button>,
        ]}
        title={title}
      >
        <InputList
          inputProps={{
            tableHeader: tableHeader,
          }}
          inputTemplate={TabulerInputTemplate}
          source={source}
          defaultValue={Array(maxLength).fill('')}
          maxFields={100}
        />
      </Modal>
    </Box>
  );
};

export default DocumentTemplateTabularDataInputs;
